import React from "react";
import { Typography } from "../../UI/Typography";

import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle";
import { Grid } from "../../UI/Grid";
import { COLOR_FIORD } from "../../constants/styles";
import { IFreeTextQuestion } from "../../constants/types";

export const FreeTextQuestion: React.FC<IFreeTextQuestion> = (props) => {
  return (
    <Grid container spacing={2} my={1}>
      <Grid item>
        <QuestionCircleIcon label="question circle" primaryColor={COLOR_FIORD} />
      </Grid>
      <Grid item xs>
        <Grid container direction="column">
          <Grid item xs mb={2}>
            <Typography fontWeight={600}>{props.questionText}</Typography>
          </Grid>
          <Grid item xs mb={3}>
            <Typography color={COLOR_FIORD}>{props.userAnswer || props.placeholder}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
